import styled from 'styled-components';
import { viewports } from 'app/shared/styles/_breakpoints';
import { colors } from 'app/shared/styles/_colors';
import { font } from 'app/shared/styles/_fontsize';
import { stacked } from 'app/shared/styles/_spacing';
import type { ComponentType } from 'react';

import PillBase from 'app/shared/modules/MobileSRP/ListingCards/FilterPills/Pill';

export const FilterTabsArticle = styled.article`
  text-align: center;
  width: 85%;
  margin: auto;
  padding: 8px 0px 0px 0px;
`;

export const FilterLabelsContainer = styled.section`
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 16px 0px 16px 0px;
  @media ${viewports['md-and-up']} {
    padding: 24px 0px 24px 0px;
  }
`;

export const FilterPill: ComponentType<React.ComponentProps<typeof PillBase>> = styled(PillBase)`
  margin-left: 4px;
  margin-right: 4px;
  margin-bottom: 10px;
`;

export const FilterPillContainer = styled.button`
  ${font.tiny};
  background: ${colors['$hpx-grey-100']};
  padding: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: flex;
  align-items: center;
  border-radius: 4px;
  &:hover {
    cursor: pointer;
  }
`;

export const FilterPillIcon = styled.img`
  margin-left: 8px;
`;

export const FilterPillCount = styled.span`
  margin-left: 4px;
  color: ${colors['$hpx-grey-600']};
`;

export const ExcludedText = styled.p`
  ${font.md};
  ${stacked._1x};
`;

export const SecondaryExcludedText = styled.p`
  ${font.md};
  color: ${colors['$hpx-grey-600']};
  margin-left: 4px;
`;

export const RemoveSomeFiltersText = styled.p`
  ${font.sm};
  color: ${colors['$hpx-grey-600']};
`;

export const ClearAllFiltersButton = styled.button`
  ${font.sm};
  margin: auto;
  text-decoration: underline;
  padding: 4px;
  color: ${colors['$hpx-grey-600']};
  &:hover {
    color: ${colors['$hpx-grey-500']};
    cursor: pointer;
  }
`;
